import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/blog.css";

const BlogPostCard = () => {
  return (
    <Fragment>
      {/* this is old code  */}
      {/* <div className="blog-details-top">
        <div className="blog-details-img">
          <img
            alt=""
            src={"/assets/img/blog/blog-5.jpg"}
          />
        </div>
        <div className="blog-details-content">
          <div className="blog-meta-2">
            <ul>
              <li>22 April, 2018</li>
              <li>
                <Link to={"/blog-details-standard"}>
                  4 <i className="fa fa-comments-o" />
                </Link>
              </li>
            </ul>
          </div>
          <h3>14 Emerging Fashion Influencers Who Are Going to Own 2018</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in reprhendit
            in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qei
            officia deser mollit anim id est laborum. Sed ut perspiciatis unde
            omnis iste natus error sit voluptatem accusantium doloremque
            laudantium, totam rem aperiam.{" "}
          </p>
          <blockquote>
            Lorem ipsum dolor sit amet, consecte adipisicing elit, sed do
            eiusmod tempor incididunt labo dolor magna aliqua. Ut enim ad minim
            veniam quis nostrud.
          </blockquote>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehendrit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur.
          </p>
        </div>
      </div>
      <div className="dec-img-wrapper">
        <div className="row">
          <div className="col-md-6">
            <div className="dec-img mb-50">
              <img
                alt=""
                src={
                  "/assets/img/blog/blog-details.jpg"
                }
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="dec-img mb-50">
              <img
                alt=""
                src={
                  "/assets/img/blog/blog-details-2.jpg"
                }
              />
            </div>
          </div>
        </div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in reprehendrit
          in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
        </p>
      </div>
      <div className="tag-share">
        <div className="dec-tag">
          <ul>
            <li>
              <Link to={"/blog-standard"}>
                lifestyle ,
              </Link>
            </li>
            <li>
              <Link to={"/blog-standard"}>
                interior ,
              </Link>
            </li>
            <li>
              <Link to={"/blog-standard"}>
                outdoor
              </Link>
            </li>
          </ul>
        </div>
        <div className="blog-share">
          <span>share :</span>
          <div className="share-social">
            <ul>
              <li>
                <a className="facebook" href="//facebook.com">
                  <i className="fa fa-facebook" />
                </a>
              </li>
              <li>
                <a className="twitter" href="//twitter.com">
                  <i className="fa fa-twitter" />
                </a>
              </li>
              <li>
                <a className="instagram" href="//instagram.com">
                  <i className="fa fa-instagram" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
      {/* <div className="next-previous-post">
        <Link to={"/blog-details-standard"}>
          {" "}
          <i className="fa fa-angle-left" /> prev post
        </Link>
        <Link to={"/blog-details-standard"}>
          next post <i className="fa fa-angle-right" />
        </Link>
      </div> */}

      <div className="blog-details">
        <h3 className="mb-4">BALI AND IT’S ORIGIN</h3>
        <p className="m-0">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi ultricies, tincidunt magna. tincidunt Suspendisse.
          <br />
          <br />
          sodales lorem pellentesque, congue enim id, rutrum nunc. Donec at
          lerisque magna, sed scelerisque nisi. Sed lobortis, massa at euismod
          volutpat, nulla urna aliquet turpis, imperdiet consequat ante mi eu
          nunc. Sed euismod erat a tincidunt fermentum. Lorem ipsum dolor sit
          amet, consectetur adipiscing elit. Mauris scelerisque pulvinar tellus
          non pulvinar. Vestibulum <br />
          pretium pretium cursus. Etiam osuere porta tincidunt. Maecenas id
          velit id velit tincidunt mollis sodales ut tortor. Maecenas at augue
          molestie, tristique mi ultricies, tincidunt magna. Suspendisse.
          sodales lorem pellentesque, congue enim id, rutrum nunc. Donec at
          lerisque magna, scelerisque nisi. Sed lobortis, Suspendisse <br />{" "}
          <br /> massa at euismod volutpat, nulla urna aliquet turpis, imperdiet
          consequat ante mi eu nunc. Sed euismod erat a tincidunt fermentum.
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum <br /> <br />{" "}
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi ultricies, tincidunt magna. Suspendisse.
        </p>

        <div className="blog-detail-content-img my-4">
          <img
            src="http://localhost:3000/static/media/home_collection_grid_6.3b2d03561c5690a0dee2.png"
            alt=""
          />
        </div>

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi id velit id velit tincidunt tincidunt ultricies,
          tincidunt magna. Suspendisse. <br />
          <br />
          sodales lorem pellentesque, congue enim id, rutrum nunc. Donec at
          lerisque magna, sed scelerisque nisi. Sed lobortis, massa at euismod
          volutpat, nulla urna aliquet turpis, imperdiet consequat ante mi eu
          nunc. Sed euismod erat a tincidunt fermentum. <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi ultricies, tincidunt magna. sodales lorem pellentesque,
          Suspendisse.
          <br /> <br /> congue enim id, rutrum nunc. Donec at lerisque magna,
          sed scelerisque nisi. Sed lobortis, massa at euismod volutpat, nulla
          urna aliquet turpis, imperdiet consequat ante mi osuere porta
          tincidunt. Maecenas id velit eu nunc. Sed euismod erat a tincidunt
          fermentum. <br /> <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi ultricies, tincidunt magna. Suspendisse.
        </p>

        <div className="row my-5">
          <div className="col-6">
            <img
              src="http://localhost:3000/static/media/home_collection_grid_6.3b2d03561c5690a0dee2.png"
              alt="Bali"
              width="100%"
            />
          </div>
          <div className="col-6">
            <img
              src="http://localhost:3000/static/media/home_collection_grid_6.3b2d03561c5690a0dee2.png"
              alt="Bali"
              width="100%"
            />
          </div>
        </div>

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi id velit id velit tincidunt tincidunt ultricies,
          tincidunt magna. Suspendisse. <br />
          <br />
          sodales lorem pellentesque, congue enim id, rutrum nunc. Donec at
          lerisque magna, sed scelerisque nisi. Sed lobortis, massa at euismod
          volutpat, nulla urna aliquet turpis, imperdiet consequat ante mi eu
          nunc. Sed euismod erat a tincidunt fermentum. <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi ultricies, tincidunt magna. sodales lorem pellentesque,
          Suspendisse.
          <br /> <br /> congue enim id, rutrum nunc. Donec at lerisque magna,
          sed scelerisque nisi. Sed lobortis, massa at euismod volutpat, nulla
          urna aliquet turpis, imperdiet consequat ante mi osuere porta
          tincidunt. Maecenas id velit eu nunc. Sed euismod erat a tincidunt
          fermentum. <br /> <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
          cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
          tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
          tristique mi ultricies, tincidunt magna. Suspendisse.
        </p>

        <div className="btn_tranding_content d-flex justify-content-between align-items-center">
          <div className="btn_blogpost">
            <Link to="/" className="button_explore">
              EXPLORE OUR BALI
            </Link>
          </div>
          <div className="tranding_link">
            <Link to="/" className="tranding">
              NEXT: Trending Jewelry Piece of Bollywood
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BlogPostCard;
